import { render } from "./CGZTarget.vue?vue&type=template&id=203e3eea&scoped=true"
import script from "./CGZTarget.vue?vue&type=script&lang=js"
export * from "./CGZTarget.vue?vue&type=script&lang=js"

import "./CGZTarget.vue?vue&type=style&index=0&id=203e3eea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203e3eea"]])

export default __exports__